import { createFileRoute } from '@tanstack/react-router'
import { DerivationsPage } from '../../../components/DerivationsPage'

export const Route = createFileRoute('/$org/derivations/')({
  component: DerivationsPageRoute,
})

function DerivationsPageRoute() {
  return <DerivationsPage />
}
